<template>
  <div
    :class="[radio ? 'radio-button' : 'checkbox-container']"
    @click.stop="doNothing"
  >
    <input
      type="checkbox"
      :name="name"
      :id="name"
      :checked="value"
      :disabled="disabled"
      @change="$emit('change', $event.target.checked)"
      :class="[size, { checkbox: !radio }]"
    />
    <label :for="name">{{ label }}</label>
  </div>
</template>

<script>
export default {
  model: {
    event: 'change',
  },
  props: {
    name: {
      type: [String, Number],
      required: true,
    },
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radio: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  methods: {
    doNothing() {
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/shared/checkbox.scss";
</style>
